import React, {  useState, useEffect, useRef } from 'react';

import { TreeSelect } from 'antd';
import '../MyOperation.css';
import FielderConst from 'FielderUtils/fielderConst';
import { listToTree, getTaskTypeListFilteredBy, hasTaskTypeFunctionality } from 'FielderUtils/taskType/taskType';
import { Row, Col } from 'react-bootstrap';
import TextField from '~/TextField/TextField.component';
import Checkbox from '~/Checkbox/Checkbox.component';

import DatePickerFielder from '../../DatePickerFielder/DatePickerFielder';
import Popup from '../../Popup';
import { duplicateTasksRequest } from '@core/api/task/task.service';

import { useLanguage } from 'Context/LanguageContext';
import { useDispatch, useSelector } from 'react-redux';
import { selectSession } from '@core/store/modules/session/sessionSelectors';

const DuplicateTaskPopup = (props) => {

	const lan = useLanguage();
	const dispatch = useDispatch();
	const session = useSelector(selectSession);
	const taskTypeFunctionality= hasTaskTypeFunctionality(session.account.funcionalityPurchases);

	const [taskTypeSelected, setTaskTypeSelected] = useState(1);
	const taskTypeSelectedRef = useRef(taskTypeSelected);

	const [dateSelected, setDateSelected] = useState(new Date());
	const dateSelectedRef = useRef(dateSelected);

	const [minTime, setMinTime] = useState(new Date());
	const minTimeRef = useRef(minTime);

	const [duplicateTaskWithUpdates, setDuplicateTaskWithUpdates] = useState(true);
	const duplicateTaskWithUpdatesRef = useRef(duplicateTaskWithUpdates);

	const [duplicateTaskAddAutomatedForms, setDuplicateTaskAddAutomatedForms] = useState(true);
	const duplicateTaskAddAutomatedFormsRef = useRef(duplicateTaskAddAutomatedForms);

	const [idBranch, setIdBranch] = useState(props.tasks[0]?.idBranch);
	const [idClient, setIdClient] = useState(props.tasks[0]?.idClient);
	const [idTasks, setIdTasks] = useState(props.idTasks);
	const [countTasks, setCountTasks] = useState(props.tasks.length);
	
	const [branchClientName, setBranchClientName] = useState(props.tasks[0]?.branch || props.tasks[0]?.taskUser);
	const duplicateTaskRef = useRef('');
	const [errorTaskReason, setErrorTaskReason] = useState(false);

	const [taskTypes, setTaskTypes] = useState([
		{
			id: 1,
			name: lan.pickup,
			children: [],
			title: lan.pickup,
			value: 1,
			key: 1,
		},
		{
			id: 2,
			name: lan.workforce,
			children: [],
			title: lan.workforce,
			value: 2,
			key: 2,
		},
		{
			id: 3,
			name: lan.delivery,
			children: [],
			title: lan.delivery,
			value: 3,
			key: 3,
		},
		{
			id: FielderConst.TASK_REMOTE_TYPE_ID,
			name: lan.remote,
			children: [],
			title: lan.remote,
			value: FielderConst.TASK_REMOTE_TYPE_ID,
			key: FielderConst.TASK_REMOTE_TYPE_ID,
		},
	]);

	useEffect(() => {
  		taskTypeSelectedRef.current = taskTypeSelected;
	}, [taskTypeSelected]);

	useEffect(() => {
  		dateSelectedRef.current = dateSelected;
	}, [dateSelected]);

	useEffect(() => {
  		minTimeRef.current = minTime;
	}, [minTime]);

	useEffect(() => {
		  		duplicateTaskWithUpdatesRef.current = duplicateTaskWithUpdates;
	}, [duplicateTaskWithUpdates]);

	useEffect(() => {
		duplicateTaskAddAutomatedFormsRef.current = duplicateTaskAddAutomatedForms;
	}, [duplicateTaskAddAutomatedForms]);		

	const getTaskDetails = (tasks) => {
		
		let taskIds = '';
		let taskIdCustom = '';

		if (tasks.length > 0) {
			const limitedTasks = tasks.slice(0, 11);

			taskIds = limitedTasks.map(task => task.taskId).join(', ');
			taskIdCustom = limitedTasks.map(task => task.customId).join(', ');

			if (tasks.length > 11) {
				taskIds += ' ...';
				taskIdCustom += ' ...';
			}
		}

		return {
			taskIds,
			taskIdCustom,
		};
	}

	const [taskDetails, setTaskDetails] = useState(getTaskDetails(props.tasks));

	useEffect(() => {
		if (taskTypeFunctionality) {
			getTaskTypeListFilteredBy(
				(formatTypes) => {
					let types = listToTree(formatTypes);
					setTaskTypes(types);
				},
				props,
				idBranch,
				idClient
			);
		}
	}, []);

	

	const duplicateTask = () => {

		if (duplicateTaskRef.current.value == '') {
			setErrorTaskReason(true);
			return;
		}

		const body = {
			idTasks: idTasks,
			taskType: taskTypeSelectedRef.current,
			year: dateSelectedRef.current.getFullYear(),
			month: dateSelectedRef.current.getMonth(),
			day: dateSelectedRef.current.getDate(),
			hour: dateSelectedRef.current.getHours(),
			minute: dateSelectedRef.current.getMinutes(),
			includeUpdatesInDuplicatedTask: duplicateTaskWithUpdatesRef.current,
			formsModified: !duplicateTaskAddAutomatedFormsRef.current,
			duplicateTaskReason: duplicateTaskRef.current.value,
		};

		console.log("body")
		console.log(body)
		const loadingConfig = { dispatch };
		const onSuccess = () => props.onClose(true,  false);
		const onError = () => props.onClose(false,  true);
			
		duplicateTasksRequest(body, onSuccess, onError, loadingConfig);
	};

	const handleProgramDate = (date) => {
		let minTime = new Date();
		if (dateSelected !== date) {
			if (
				date.getDate() !== new Date().getDate() ||
				date.getMonth() !== new Date().getMonth() ||
				date.getFullYear() !== new Date().getFullYear()
			) {
				minTime = new Date().setHours(0, 0);
			}
			setDateSelected(date);
			setMinTime(minTime);
		}
	};


	return (
		<React.Fragment>
			<Popup
				title={lan.duplicateTask + ' (' + countTasks + ') '}
				icon='detalle-task-icon.svg'
				show
				closeButton
				onClose={props.onClose}
				buttonText={lan.duplicateTask}
				requiredFields={lan.requiredFields}
				buttonOnClick={duplicateTask}
				size={'auto'}
			>
				<Row>
					<Col sm={12}>
						{/* Task Type */}
						<div className='mt-1'>
							<Row>
								<Col className='small-popup-label'>{lan.idTask}</Col>
							</Row>
							<Row>
								<Col className='popup-label my-2 ml-2'>{taskDetails.taskIds}</Col>
							</Row>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<div className=''>
							<Row>
								<Col className='small-popup-label'>{lan.idCustom}</Col>
							</Row>
							<Row>
								<Col className='popup-label my-2 ml-2'>{taskDetails.taskIdCustom}</Col>
							</Row>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						{idBranch ? (
							<div className=''>
								<Row>
									<Col className='small-popup-label'>{lan.branch}</Col>
								</Row>
								<Row>
									<Col className='popup-label my-2 ml-2'>{branchClientName}</Col>
								</Row>
							</div>
						) : (
							<div className=''>
								<Row>
									<Col className='small-popup-label'>{lan.client}</Col>
								</Row>
								<Row>
									<Col className='popup-label my-2 ml-2'>{branchClientName}</Col>
								</Row>
							</div>
						)}
					</Col>
				</Row>
				<Row>
					<Col sm={12} className='ml-3 mb-3 title-padding text-title'>
						<span> {lan.typeOfTask} </span>
					</Col>
					<Col className='col-10 ml-3 mb-3 create-task-dropdown-size' key='col-task-taskType'>
						<TreeSelect
							className='full-width'
							treeData={taskTypes}
							dropdownStyle={{ maxHeight: '400px', overflow: 'auto' }}
							onChange={(e) => setTaskTypeSelected(e)}
							placeholder={lan.taskType}
							value={taskTypeSelected} 
							//defaultValue={taskTypeSelected}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<span className='title-padding text-title'>{lan.startWay}</span>

						<DatePickerFielder
							id='executionDate-red-input'
							selected={dateSelected}
							handleDate={handleProgramDate}
							minDate={new Date()}
							timeFormat='HH:mm'
							minTime={minTime}
							maxTime={new Date().setHours(23, 59)}
							dateFormat='dd/MM/yyyy h:mm aa' //Formato de fecha
							timeIntervals={30} //Intervalo de tiempo en minutos
							classNamePicker='MyOperation-eschedule form-control mt-1 text-left'
							imgId='executionDate-alert-icon'
							classNameImg='CreateTask-dir-desc-fieldContainer-icon'
						/>
					</Col>
				</Row>
				<Row className='ml-1 mt-2'>
					<Col sm>
						<div className=''>
							<Row>
								<Checkbox
									label={lan.duplicateTaskWithUpdates}
									checked={duplicateTaskWithUpdates}
									onChange={(e) => {
										setDuplicateTaskWithUpdates(!duplicateTaskWithUpdates);
									}}
								/>
							</Row>
						</div>
					</Col>
					<Col sm>
						<div className=''>
							<Row>
								<Checkbox
									label={lan.duplicateTaskAddAutomatedForms}
									checked={duplicateTaskAddAutomatedForms}
									onChange={(e) => {
										setDuplicateTaskAddAutomatedForms(!duplicateTaskAddAutomatedForms);
									}}
								/>
							</Row>
						</div>
					</Col>
				</Row>

				<Row>
					<Col sm={12}>
						<TextField
							id='txt-duplicate-task-reason'
							label={lan.duplicateTaskReason}
							multiline
							rows={5}
							fullWidth
							defaultValue={duplicateTaskRef.current.value}
							onChange={(e) => {
								if ( e.target.value !== '') {
									setErrorTaskReason(false);
								}
							}}
							inputRef={duplicateTaskRef}
							maxSize={250}
							variant='outlined'
							error={duplicateTaskRef.current.value === '' && errorTaskReason}
						/>
					</Col>
				</Row>

			</Popup>
		</React.Fragment>
	);
}


export default DuplicateTaskPopup;
